import { connect } from 'react-redux';
import { compose } from 'recompose';
import { injectIntl } from 'react-intl';

import { withAvatarUpload } from 'modules/user/hocs/avatarUpload';
import { getUserFullNameWithMiddleName, getUserInitials } from 'modules/user/utils/user';
import { saveAvatar } from 'modules/user/actions/saveAvatar';
import { getUsersReadPermissions, getUsersUpdatePermissions } from 'modules/session/selectors/permissions';

import UserDetailsInfo from './UserDetailsInfo';

const mapStateToProps = (state) => {
  const { firstName, lastName, middleName, avatar } = state.auth.userInfo.profile;
  const userReadPermissions = getUsersReadPermissions(state);
  const userUpdatePermissions = getUsersUpdatePermissions(state);

  return {
    avatar,
    userReadPermissions,
    userUpdatePermissions,
    initials: getUserInitials({ firstName, lastName }),
    fullName: getUserFullNameWithMiddleName({ firstName, lastName, middleName }),
  };
};

const mapDispatchToProps = {
  saveAvatar,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),

  injectIntl,
  withAvatarUpload,
)(UserDetailsInfo);
